import { useCallback, useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr'
import { getAuctionInfoKey } from '../../api-client/auction'
import { ListingType } from '../../api-client/enums'

export default function useSignalr(vehicleId, listingType, redirectWinnerToPurchase) {
  const signalrConRef = useRef(null)
  const queryClient = useQueryClient()

  const setUpSignalRConnection = useCallback(
    async (vehicleId) => {
      const connection = new HubConnectionBuilder()
        .withUrl(process.env.NEXT_PUBLIC_SIGNALR_AUCTION_DOMAIN)
        .withAutomaticReconnect()
        .build()

      connection.on('BidPlaced', () => {
        queryClient.invalidateQueries(getAuctionInfoKey)
      })
      connection.on('AuctionStarted', () => {
        queryClient.invalidateQueries(getAuctionInfoKey)
      })
      connection.on('AuctionEnded', () => {
        queryClient.invalidateQueries(getAuctionInfoKey)
        redirectWinnerToPurchase()
      })
      connection.on('AuctionExtended', () => {
        queryClient.invalidateQueries(getAuctionInfoKey)
      })
      connection.on('AuctionStopped', () => {
        queryClient.invalidateQueries(getAuctionInfoKey)
      })

      try {
        await connection.start()
      } catch (err) {
        alert("SignalR couldn't connect")
        console.log("SignalR couldn't connect: " + err)
      }

      if (connection.state === HubConnectionState.Connected) {
        connection.invoke('AddToGroup', vehicleId).catch((err) => {
          console.log("SignalR couldn't AddToGroup " + err)
        })
      }

      return connection
    },
    [queryClient, redirectWinnerToPurchase],
  )

  useEffect(() => {
    if (!vehicleId || listingType === ListingType.BuyNow) return
    if (!signalrConRef.current) {
      setUpSignalRConnection(vehicleId).then((con) => {
        signalrConRef.current = con
      })
    }

    return () => signalrConRef.current?.stop()
  }, [vehicleId, listingType, setUpSignalRConnection])
}
